import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function updateTicketDetails(payload) {
  try {
    const data = await authenticatedFetch(URL.updateTicketDetails, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return data;
  } catch (error) {
    console.error("Error updating the holidays list:", error);
    throw error;
  }
}
